import Div from './Div.js';

export default class Time extends Div
{
	set value(value)
	{
		const t = new Date(0);
		t.setUTCSeconds(value||0);
		this.element.setAttribute('data-duration',`${t.getUTCMinutes()}:${('0'+t.getUTCSeconds()).slice(-2)}`);
	}
	set live(value)
	{
		this.element.classList.toggle('live',value);
	}
}
